import React, {useState} from 'react';
import 'styles/Navbar.scss';
import { useLocation, useNavigate } from 'react-router-dom';  // Import useLocation to get current route
import { useAuth } from '../../../context/AuthContext';
import userAvtar from '../../../assets/profile-avtar.png'
import axelLogo from '../../../assets/axel-marketplace.png'
// import logoMarketplace from '../../../assets/logo-marketplace.svg'
// import { useState } from 'react';

const Navbar = ({ toggleSidebar }) => {
    const location = useLocation(); // Get the current route
    const navigate = useNavigate();
    const { logout } = useAuth();

    const [isDropdownOpen, setDropdownOpen] = useState(false); // Dropdown state
    const [isLoggingOut, setIsLoggingOut] = useState(false); // Logout loading state

    const toggleDropdown = () => {
        setDropdownOpen(!isDropdownOpen); // Dropdown between true/false
    };

    const closeDropdown = () => {
        setDropdownOpen(false);
    };

    const handleLogout = async () => {
        setIsLoggingOut(true);
        closeDropdown(); // Close dropdown
        
        try {
            await logout(); // This calls the auth context logout which calls the API
            navigate('/login');
        } catch (error) {
            // Even if API call fails, still log out locally and redirect
            navigate('/login');
        } finally {
            setIsLoggingOut(false);
        }
    };

    // Check if the current path is "/login" or "/register"
    const isLoginPage = location.pathname === '/login' || location.pathname === '/register';

    return (
        <nav className="navbar z-50 py-8 text-white bg-black w-full border-b border-gray-800">
            <div className='container mx-auto px-4 flex justify-between items-center'>
                <a href="/" className="brand-logo flex items-center cursor-pointer">
                    {/* <img src={axelLogo} alt="Axel" />
                    <img src={logoMarketplace} className='ml-3' alt="Marketplace" /> */}
                    <img src={axelLogo} className="w-72" alt="Axel Marketplace" />
                </a>
            
                {/* Conditionally render the toggle button if NOT on the login page */}
                {/* {!isLoginPage && (
                    <div className='flex'>
                        <button className='rounded-full py-3 px-7 bg-transparent border-white border-2 self-center hover:border-white hover:bg-white hover:text-violet-900 transition-all'>
                            My Account
                        </button>
                        <button className='rounded-full py-3 px-7 bg-transparent border-white border-2 ml-5 self-center hover:border-white hover:bg-white hover:text-violet-900 transition-all'>
                            Register
                        </button>
                    </div>
                )} */}
                {!isLoginPage && (
                        <div className='flex'>
                            <button className="menu-toggle p-1 cursor-pointer bg-transparent mx-5  self-center" onClick={toggleSidebar}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" className="bi fill-current bi-list" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                                </svg>
                            </button>
                            <div className='relative'>
                            
                            <button type="button" className='flex items-center bg-transparent relative after:content-[""] after:absolute after:w-2 after:h-2 after:bg-rose-600 after:rounded-full after:bottom-0.5 after:right-0' onClick={toggleDropdown}>
                                <img src={userAvtar} className='w-11 rounded-full' alt="User" />
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a8a8a8" className="ms-2" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg> */}
                            </button>
                            
                            {/* Backdrop to close dropdown when clicking outside */}
                            {isDropdownOpen && (
                                <div 
                                    className="fixed inset-0 z-10 bg-transparent"
                                    onClick={closeDropdown}
                                />
                            )}
                            
                            <div className={`profile-dropdown z-20 absolute w-[200px] bg-white py-2 right-0 top-full shadow mt-3 rounded ${isDropdownOpen ? 'block' : 'hidden'}`}>
                                <ul>
                                    <li 
                                        className='flex cursor-pointer items-center gap-2 px-5 py-2 transition-all hover:bg-violet-300 hover:text-white text-violet-900'
                                        onClick={() => {
                                            closeDropdown();
                                            navigate('/profile');
                                        }}
                                    > 
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-user-icon text-muted"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                        Profile
                                    </li>
                                    <li 
                                        className='flex cursor-pointer items-center gap-2 px-5 py-2 transition-all hover:bg-violet-300 hover:text-white text-violet-900'
                                        onClick={() => {
                                            closeDropdown();
                                            navigate('/account');
                                        }}
                                    > 
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-settings-icon text-muted"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                        Account
                                    </li>
                                    <li 
                                        className='flex cursor-pointer items-center gap-2 px-5 py-2 transition-all hover:bg-violet-300 hover:text-white text-violet-900'
                                        onClick={() => {
                                            closeDropdown();
                                            navigate('/settings');
                                        }}
                                    > 
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-settings-icon text-muted"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                        Settings
                                    </li>
                                    <li className="py-1">
                                        <hr className="border-0 border-b border-b-gray-200 dark:border-b-gray-700" />
                                    </li>
                                    <li 
                                        className={`flex cursor-pointer items-center gap-2 px-5 py-2 transition-all hover:bg-violet-300 hover:text-white text-violet-900 ${isLoggingOut ? 'opacity-50 cursor-wait' : ''}`}
                                        onClick={handleLogout}
                                        disabled={isLoggingOut}
                                    > 
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-log-out text-muted">
                                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                            <polyline points="16,17 21,12 16,7"></polyline>
                                            <line x1="21" y1="12" x2="9" y2="12"></line>
                                        </svg>
                                        {isLoggingOut ? 'Logging out...' : 'Log Out'}
                                    </li>
                                </ul>
                            </div>
                            </div>
                        </div>
                    )}
            </div>
        </nav>
    );
};

export default Navbar;
